import React from 'react'
import Form from './components/Form'

export const App = () => {
  return (
    <Form />
    
  )


}

